import * as Const from '../constants/actionConstants';

import { Action } from 'redux';

import ExistSubMessage from '../interfaces/actions/ExistSubMessage';
import ExistSubscription from '../interfaces/ExistSubscription';
import ExistSubSubscription from '../interfaces/actions/ExistSubSubscription';
import EditExistSubId from '../interfaces/actions/EditExistSubId';
import EditExistSubWidth from '../interfaces/actions/EditExistSubWidth';
import EditExistSubDatetimeFinish from '../interfaces/actions/EditExistSubDatetimeFinish';

export const existSubIsLoading = (): Action => {
  return {
    type: Const.EXIST_SUB_IS_LOADING,
  };
};

export const existSubMessage = (message = 'Request was sent'): ExistSubMessage => {
  return {
    type: Const.EXIST_SUB_MESSAGE,
    message,
  };
};

export const existSubSubscription = (existSubscription: ExistSubscription[]): ExistSubSubscription => {
  return {
    type: Const.EXIST_SUB_SUBSCRIPTIONS,
    existSubscription,
  };
};

export const editExistSubId = (id: number): EditExistSubId => {
  return {
    type: Const.EDIT_EXIST_SUB_ID,
    id,
  };
};

export const editExistSubDatetimeFinish = (datetime_finish: Date): EditExistSubDatetimeFinish => {
  return {
    type: Const.EDIT_EXIST_SUB_CHANGE_DATETIME_FINISH,
    datetime_finish,
  };
};

export const existSubNotLoading = (): Action => {
  return {
    type: Const.EXIST_SUB_NOT_LOADING,
  };
};

export const editExistSubWidth = (width: number): EditExistSubWidth => {
  return {
    type: Const.EDIT_EXIST_SUB_WIDTH,
    width,
  };
};
